import { EPersona } from '@sharedInterfaces/EPersona';
import type { IOpportunitySettings, TEntityVersions } from '@sharedInterfaces/ICompany';
import type { ILevel, IOU, IStyleDTO } from '@sharedInterfaces/ICompanySettings';
import type IEmployeeSettingsDTO from '@sharedInterfaces/IEmployeeSettings';
import type { IAdminNotification, IEmployeeNotification } from '@sharedInterfaces/INotification';
import type { IPermissions } from '@sharedInterfaces/IPermissions';
import type IWhoIAm from '@sharedInterfaces/IWhoIAm';
import type {
    ISmallCertificate,
    ISmallCompetence,
    ISmallEmployee,
    ISmallRole,
    ISmallSkill,
} from '@sharedInterfaces/IWhoIAm';
import type { ELanguage } from '@sharedInterfaces/Language/languageHelper';

import type IUser from '../interfaces/IUser';
import Employee from './Employee';
import { SkillCategory } from './SkillCategory';

export default class WhoIAm implements IWhoIAm {
    companyTitle: string;
    user: IUser;
    employee: Employee;
    smallCompetences: ISmallCompetence[];
    smallSkills: ISmallSkill[];
    smallCertificates: ISmallCertificate[];
    skillCategories: SkillCategory[];
    smallEmployees: ISmallEmployee[];
    smallRoles: ISmallRole[];

    style: IStyleDTO;
    OUs: IOU[];
    level: ILevel[];
    notifications: IEmployeeNotification[];
    adminNotifications: IAdminNotification[];
    employeeSettings: IEmployeeSettingsDTO;
    permissions: IPermissions;
    unknownSkillCount: number;
    versions: TEntityVersions;
    language: ELanguage | null;
    opportunitySettings: IOpportunitySettings;
    personas: EPersona[];
    constructor(obj: IWhoIAm) {
        this.user = obj.user;
        this.employee = new Employee(obj.employee);
        this.smallSkills = obj.smallSkills; //.map(i => ({ ...i, id: parseInt(<string><unknown>i.id) }));
        this.smallCertificates = obj.smallCertificates;
        this.skillCategories = obj.skillCategories.map((e) => new SkillCategory({ ...e, employees: [] }));
        this.smallEmployees = obj.smallEmployees;
        this.smallRoles = obj.smallRoles;
        this.style = obj.style;
        this.companyTitle = obj.companyTitle;
        this.OUs = obj.OUs;
        this.level = obj.level;
        this.employeeSettings = obj.employeeSettings;
        this.notifications = obj.notifications;
        this.adminNotifications = obj.adminNotifications;
        this.permissions = obj.permissions;
        this.smallCompetences = obj.smallCompetences;
        this.unknownSkillCount = obj.unknownSkillCount;
        this.language = obj.language;
        this.opportunitySettings = obj.opportunitySettings;
        this.versions = obj.versions;
        this.personas = obj.personas || [EPersona.Employee];
    }
}
